import { Component } from '@angular/core';
import { ViewController, NavParams, AlertController, ToastController, ModalController } from "ionic-angular";
import { FoodsProvider } from '../../../providers/foods/foods';
import { Params } from '../../params';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import { ModalRecipesPage } from '../modal-recipes/modal-recipes';
import { GlobalProvider } from "../../../providers/global/global";

/**
 * Generated class for the ModalDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-modal-detail',
  templateUrl: 'modal-detail.html',
})
export class ModalDetailPage {
  title: string = "Viendo ";
  charge;
  day;
  tabs = "foods";
  activeFood = {};
  hideings = {
    aco: false,
    prin: false,
    extras: false,
    uni: false
  }
  groupingredients = null;
  totalKcal = 0;
  foods = [];
  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public foodServ: FoodsProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public global: GlobalProvider
  ) {
    this.charge = this.navParams.get('data')['charge'];
    if (this.charge) {
      this.title = "Viendo " + this.charge.customer.name;
      this.activeFood = this.charge.foods.detail[0];
      this.activeFood['active'] = true;
      // this.calcNutritions();
      this.totalKcal = this.charge.foods.detail
        ?.map((x) => x.prod.nutritional?.Kcal)
        .reduce((a, b) => a + b, 0);
    }
    this.day = this.navParams.get('data')['day'];
    console.log(this.charge, this.day)
    if (this.charge) {
      console.log(this.charge.foods.detail)
    }
    this.groupingredients = this.global.gingredients;
    this.foods = this.global.foods;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalDetailPage');
  }

  imageURL(p) {
    let url = 'assets/img/photo.jpg';
    if (Object.keys(p).length) {
      if (p.imageList.length) {
        url = p.imageList[0].downloadURL;
      }
    }
    return url;
  }

  showRestrictions() {
    let alert = this.alertCtrl.create();
    if (this.charge.customer.restrictions.length) {
      alert.setTitle("Restricciones de " + this.charge.customer.name);
      let txt = "";
      for (let r of this.charge.customer.restrictions) {
        txt +=
          Params.restrictionType(r.type) +
          " <br> <b>[" +
          r.value +
          "] " +
          r.value_name +
          "</b><br><br>";
      }
      alert.setMessage(txt);
    } else {
      alert.setSubTitle(this.charge.customer.name + " no tiene restricciones");
    }
    alert.addButton("Entendido");
    alert.present();
  }

  showConditions() {
    let alert = this.alertCtrl.create();
    if (Object.keys(this.charge.customer.conditions).length) {
      alert.setTitle("Condiciones de " + this.charge.customer.name);
      let txt = "";
      let conds = Object.keys(this.charge.customer.conditions);
      for (let c of conds) {
        // console.log('c ', c);
        let food = this.foods.filter((f: any) => f.value == c);
        // console.log('foods conditions ', food[0]);
        if (food) {
          txt +=
            "[" +
            c +
            "] " +
            food[0]?.name +
            " <br> <b>" +
            this.charge.customer.conditions[c] +
            "</b><br><br>";
        }
      }
      alert.setMessage(txt);
    } else {
      alert.setSubTitle(this.charge.customer.name + " no tiene condiciones");
    }
    alert.addButton("Entendido");
    alert.present();
  }

  solveChangeProdRestrictions(prod) {
    this.charge.foods.restrictions.detail =
      this.charge.foods.restrictions.detail.map((r) => {
        if (r.prod == prod) {
          r.solved = true;
          r.solution = {
            type: 3,
            ingredient: "",
            newRecipe: "",
          };
        }
        return r;
      });
  }

  checkRestriction(recipe) {
    return new Promise((resolve, reject) => {
      //check recipe
      this.charge.customer.restrictions.forEach((r) => {
        if (r.type === 1) {
          // ingrediente
          const ings = [];
          for (let i of recipe.ingredients) {
            const f2 = this.charge.customer.restrictions.filter((x) => {
              return i.code == x.value || x.ings.indexOf(i.code) !== -1;
            });
            if (f2.length) ings.push(f2[0]);
          }
          if (ings.length) {
            resolve({ found: true, type: "ingredientes", detail: ings });
          }
        }
        if (r.type === 2) {
          //grupo de ingredientes
          const group = this.groupingredients[r.value];
          if (group) {
            group.ingredients.forEach((i) => {
              if (recipe.ingredients.map((r) => r.code).indexOf(i) !== -1) {
                resolve({
                  found: true,
                  type: "grupo de ingredientes",
                  detail: [r],
                });
              }
            });
          } else {
            alert(
              "El grupo de ingredientes " +
              r.value +
              " del cliente no existe en IRP"
            );
          }
        }
        if (r.type === 3) {
          // receta
          if (recipe.code === r.value) {
            resolve({ found: true, type: "receta", detail: [r] });
          }
        }
      });
      resolve({ found: false });
    });
  }

  removeIngredient(i, r, del) {
    if (del) {
      let alert = this.alertCtrl.create();
      alert.setTitle("Advertencia");
      alert.setMessage(
        "Va a quitar <b>" +
        i.name +
        "</b> a la receta <b>" +
        r.name +
        "</b> de " +
        this.charge.customer.name +
        ". ¿Desea continuar?"
      );
      alert.addButton("No");
      alert.addButton({
        text: "Si",
        handler: (data) => {
          i.deleted = true;
          this.activeFood["history"].push({
            action: "remove-ingredient",
            detail: {
              code: i.code,
              name: i.name,
              recipe: r.name,
              recipeCode: r.code,
            },
            owner: {
              id: firebase.auth().currentUser.uid,
              name: firebase.auth().currentUser.displayName,
            },
            date: moment().format(),
          });

          let s = this.checkIngredient(i, r.code, false);
          s[0].solved = true;
          s[0].solution = {
            type: 2,
            ingredient: i.name,
            newRecipe: "",
          };

          if (this.checkAllRestrictionsAlright() === 0) {
            this.charge.foods.restrictions.solved = true;
          }

          this.saveChanges();
        },
      });
      alert.present();
    } else {
      i.deleted = false;
      this.activeFood["history"].push({
        action: "undo-remove-ingredient",
        detail: {
          code: i.code,
          name: i.name,
          recipe: r.name,
          recipeCode: r.code,
        },
        owner: {
          id: firebase.auth().currentUser.uid,
          name: firebase.auth().currentUser.displayName,
        },
        date: moment().format(),
      });

      let s = this.checkIngredient(i, r.code, true);
      s[0].solved = false;
      s[0].solution = {};
      this.charge.foods.restrictions.solved = false;
      this.saveChanges();
    }
  }

  checkAllRestrictionsAlright() {
    return this.charge.foods.restrictions.detail.filter((x) => !x.solved)
      .length;
  }

  editName(food) {
    const prompt = this.alertCtrl.create({
      title: "Editar producto",
      message: "Ingrese el nombre del producto",
      inputs: [
        {
          name: "name",
          placeholder: "Nombre",
          value: food.prod.name,
        },
      ],
      buttons: [
        {
          text: "Cancelar",
          handler: (data) => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Editar",
          handler: (data) => {
            console.log(data);
            food.prod.name = data.name;
            this.activeFood["history"].push({
              action: "edit-name",
              detail: food.code,
              owner: {
                id: firebase.auth().currentUser.uid,
                name: firebase.auth().currentUser.displayName,
              },
              date: moment().format(),
            });
            this.saveChanges();
          },
        },
      ],
    });
    prompt.present();
  }

  editPortion(food) {
    const prompt = this.alertCtrl.create({
      title: "Editar porción",
      message: "Ingrese la nueva porción",
      inputs: [
        {
          name: "name",
          placeholder: "Porción",
          value: food.calcportion,
        },
      ],
      buttons: [
        {
          text: "Cancelar",
          handler: (data) => {
            console.log("Cancel clicked");
          },
        },
        {
          text: "Editar",
          handler: (data) => {
            console.log(data);
            food.calcportion = data.name;
            food.tportion = "f";
            this.activeFood["history"].push({
              action: "edit-portion",
              detail: food.id,
              owner: {
                id: firebase.auth().currentUser.uid,
                name: firebase.auth().currentUser.displayName,
              },
              date: moment().format(),
            });
            this.saveChanges();
          },
        },
      ],
    });
    prompt.present();
  }

  changeProduct(id) {
    let alert = this.alertCtrl.create();
    alert.setTitle("¿Qué tipo de producto desea elegir?");

    alert.addInput({
      type: "radio",
      label: "Compuesto",
      value: "CO",
      checked: true,
    });

    alert.addInput({
      type: "radio",
      label: "Único",
      value: "UN",
    });

    alert.addButton("Cancelar");
    alert.addButton({
      text: "Elegir",
      handler: (data) => {
        console.log(data);
        this.solveChangeProdRestrictions(id);
        this.checkAllRestrictionsAlright();
        this.activeFood["prod"] = {
          active: true,
          category: "",
          chefwords: "",
          cost: 0,
          description:
            "Conocemos tus gustos y restricciones, por lo mismo hemos reemplazado este producto.",
          duration: 0,
          family: [],
          id: "9999",
          imageList: [
            {
              downloadURL:
                "https://firebasestorage.googleapis.com/v0/b/fitfood-22c23.appspot.com/o/default.jpg?alt=media&token=8a657592-a9c9-42f0-8e2c-1a15e18dc467",
              name: "jpg_jue-27-junio-fit-food-app_diego-figueroa-1x1-7.jpg",
              size: 507871,
              type: "image/jpeg",
            },
          ],
          name: "Producto Custom",
          nutritional: { Cho: 0, Kcal: 0, Lip: 0, Pro: 0, Sodio: 0 },
          package: "CA1000",
          project: "",
          recipes_accompaniment: [],
          recipes_extra: [],
          recipes_principal: [],
          recipes_uniques: [],
          type: data,
        };
        this.activeFood["history"].push({
          action: "custom-prod",
          detail: "",
          owner: {
            id: firebase.auth().currentUser.uid,
            name: firebase.auth().currentUser.displayName,
          },
          date: moment().format(),
        });
      },
    });
    alert.present();
  }

  changeRecipe(f, type) {
    if (this.activeFood["prod"][type]) {
      const index =
        this.activeFood["prod"][type].indexOf(f) != -1
          ? this.activeFood["prod"][type].indexOf(f)
          : 0;
      let modal = this.modalCtrl.create(ModalRecipesPage);
      modal.present();
      modal.onDidDismiss((resp) => {
        if (resp) {
          console.log("recipe selected", resp);
          this.checkRestriction(resp.recipe)
            .then((r: any) => {
              if (r.found) {
                let alert = this.alertCtrl.create();
                alert.setTitle("Advertencia");
                let txt =
                  "La nueva receta también tiene restricciones en " +
                  r.type +
                  " <br><br>";
                for (let d of r.detail) {
                  txt +=
                    "<b>" +
                    d.value_name +
                    "</b> [" +
                    d.value +
                    "] por " +
                    d.reason +
                    "<br>";
                }
                alert.setMessage(txt);
                alert.addButton("Cambiaré de receta");
                alert.addButton({
                  text: "Deseo mantener de todas formas",
                  handler: () => {
                    // enviar la restriccion y dejar la receta para quitar ingrediente
                    this.executeChangeRecipe(f, resp, type, index);
                  },
                });
                alert.present();
              } else {
                this.executeChangeRecipe(f, resp, type, index);
              }
            })
            .catch((e) => console.log(e));
        }
      });
    }
  }

  executeChangeRecipe(f, resp, type, index) {
    console.log("executeChangeRecipe");
    if (f != null) {
      this.activeFood["history"].push({
        action: "recipe-change",
        detail: f.id,
        owner: {
          id: firebase.auth().currentUser.uid,
          name: firebase.auth().currentUser.displayName,
        },
        date: moment().format(),
      });
      const check = this.checkRecipe(f);
      for (let j = 0; j < check.length; j++) {
        check[j].solution = {
          newRecipe: resp.recipe.id,
          type: 1,
          ingredient: "",
        };
        check[j].solved = true;
      }
    } else {
      this.activeFood["history"].push({
        action: "recipe-added",
        detail: resp.recipe.id,
        owner: {
          id: firebase.auth().currentUser.uid,
          name: firebase.auth().currentUser.displayName,
        },
        date: moment().format(),
      });
    }

    this.activeFood["prod"][type][index] = resp.recipe;
    let newName = "";
    if (this.activeFood["prod"].type == "CO") {
      if (this.activeFood["prod"]["recipes_principal"][0]) {
        newName += this.activeFood["prod"]["recipes_principal"][0].name;
        this.activeFood["prod"]["recipes_principal"][0].calcportion =
          this.charge.customer.portions.principal;
        this.activeFood["prod"]["recipes_principal"][0].tportion = "v";
      }
      newName += " y ";
      if (this.activeFood["prod"]["recipes_accompaniment"][0]) {
        newName += this.activeFood["prod"]["recipes_accompaniment"][0].name;
        this.activeFood["prod"]["recipes_accompaniment"][0].calcportion =
          this.charge.customer.portions.accompaniment;
        this.activeFood["prod"]["recipes_accompaniment"][0].tportion = "v";
      }
    } else {
      if (this.activeFood["prod"]["recipes_uniques"][0]) {
        newName = this.activeFood["prod"]["recipes_uniques"][0].name;
        this.activeFood["prod"]["recipes_uniques"][0].calcportion =
          this.charge.customer.portions.unique;
        this.activeFood["prod"]["recipes_uniques"][0].tportion = "v";
      }
    }

    if (this.checkAllRestrictionsAlright() === 0) {
      this.charge.foods.restrictions.solved = true;
    }

    const portions = {
      p: this.charge.customer.portions.principal,
      a: this.charge.customer.portions.accompaniment,
      v: this.charge.customer.portions.unique,
    };

    this.activeFood["prod"] = this.foodServ.calcProdNutritionals(
      this.activeFood["prod"],
      portions
    );
    this.activeFood["prod"].cost = this.foodServ.calcProdCost(
      this.activeFood["prod"],
      portions
    );

    this.activeFood["prod"] = this.foodServ.setCustomProd(
      this.activeFood["prod"]
    );

    let alert = this.alertCtrl.create();
    alert.setTitle("Nuevo producto");
    let txt =
      "Con el cambio de receta te recomendamos dejar el producto con el siguiente nombre:";
    alert.setMessage(txt);
    alert.addInput({
      value: newName,
      name: "newName",
    });

    alert.addButton({
      text: "Cambiar nombre",
      handler: (data) => {
        console.log("nuevo nombre", data.newName);
        this.activeFood["prod"].name = data.newName;
        this.saveChanges();
      },
    });
    alert.present();
  }

  checkRecipe(r) {
    return this.charge.foods.restrictions.detail.filter((x) => {
      return (
        x.prod === this.activeFood["prod"].id &&
        x.recipeCode === r.code &&
        !x.solved
      );
    });
  }

  checkIngredient(i, r, solved) {
    return this.charge.foods.restrictions.detail.filter((x) => {
      return (
        x.prod === this.activeFood["prod"].id &&
        x.recipeCode === r &&
        x.type === "i" &&
        x.ingCode === i.code &&
        x.solved == solved
      );
    });
  }

  checkProduct(p, solved) {
    return this.charge.foods.restrictions.detail.filter(
      (x) => x.prod === p.prod.id && (x.solved == solved || solved == null)
    ).length;
  }

  selectFood(f) {
    this.removeActives();
    f.active = true;
    this.activeFood = f;
    console.log(f);
  }

  calcNutritions() {
    if (this.charge.foods.detail) {
      this.totalKcal = 0;
      const portions = {
        p: this.charge.customer.portions.principal,
        a: this.charge.customer.portions.accompaniment,
        v: this.charge.customer.portions.unique,
      };
      this.charge.foods.detail = this.charge.foods.detail.map((p) => {
        if (Object.keys(p.prod).length) {
          p.prod = this.foodServ.calcProdNutritionals(p.prod, portions);
          this.totalKcal = this.totalKcal + p.prod.nutritional.Kcal;
        }
        return p;
      });
    }
  }

  gender(c) {
    const g = {
      F: "Mujer",
      M: "Hombre",
    };
    if (g[c]) {
      return g[c];
    } else {
      return "N/A";
    }
  }

  removeActives() {
    this.charge.foods.detail.map((d) => {
      d.active = false;
      return d;
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  saveChanges() {
    firebase
      .firestore()
      .collection("orders")
      .doc(this.day.dayYMD)
      .collection("data")
      .doc(this.charge.customer.id)
      .set(this.charge)
      .then(() => {
        const toast = this.toastCtrl.create({
          message: "Cambios guardados exitosamente",
          duration: 3000,
        });
        toast.present();
      })
      .catch((e) => console.log(e));
  }
}



// WEBPACK FOOTER //
// ./src/pages/days/modal-detail/modal-detail.ts